import { render } from "./ChangeOwnPasswordModal.vue?vue&type=template&id=1d5cacb7&ts=true"
import script from "./ChangeOwnPasswordModal.vue?vue&type=script&lang=ts"
export * from "./ChangeOwnPasswordModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__